<div class="layout-row-gap-05 layout-align-center">
  <div [innerHTML]="data.html" ></div>
  <button mat-stroked-button (click)="snackBar.dismiss()" color="accent">{{data.label}}</button>
</div>
